// @flow
import * as React from 'react';
import Prism from 'prismjs';
import { withTheme } from 'styled-components';
import 'prismjs/themes/prism-okaidia.css';

type SupportedProgrammingLanguage = 'javascript';

type Props = {
  children: string;
  language: SupportedProgrammingLanguage;
  theme: Object;
}

class CodeSnippet extends React.Component<Props> {
  _domNode: any;

  componentDidMount() {
    this.performHighlighting();
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.children !== this.props.children) {
      this.performHighlighting();
    }
  }

  performHighlighting() {
    Prism.highlightElement(this._domNode);
  }

  onRefMounted = (domNode: any) => {
    this._domNode = domNode;
  }

  render() {
    const { children, language, theme } = this.props;

    return (
      <pre style={{ fontSize: theme.fonts.style.xxsmall.fontSize }} className={`language-${language}`} ref={this.onRefMounted}>
        {children}
      </pre>
    );
  }
}

export default withTheme(CodeSnippet);



// WEBPACK FOOTER //
// ./src/common/components/CodeSnippet.js